export default "__VITE_ASSET__DdH6ky5P__"